
import './InputComponent.css';

import minussquare from "../../assets/minus-square.svg";
import addsquare from "../../assets/add-square.svg";

const CounterInputComponent = ({
    placeholder,
    value,
    decrement,
    increment
}) => {
    return (
        <div className="input-group number-group">
            <div className="number-input">
                <label>{placeholder}</label>
                <img src={minussquare} alt='minussquare' onClick={decrement} style={{ cursor: 'pointer' }} />
                <span className="number-value">{value?.toString().padStart(2, '0')}</span>
                <img src={addsquare} alt='addsquare' onClick={increment} style={{ cursor: 'pointer' }} />
            </div>
        </div>
    );
};

export default CounterInputComponent;
